import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import React from 'react';
import styled from '@emotion/styled';
import Tooltip, { TooltipPrimitive } from '@atlaskit/tooltip';
import { Box, xcss } from '@atlaskit/primitives';
var AIIndicatorTooltipPrimitive = styled(TooltipPrimitive)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  box-sizing: content-box;\n  padding: ", ";\n  max-width: 350px;\n"])), "var(--ds-border-radius, 3px)", "var(--ds-surface-raised, white)", "var(--ds-shadow-overlay, 0px 8px 12px rgba(9, 30, 66, 0.15),0px 0px 1px rgba(9, 30, 66, 0.31))", "var(--ds-space-200, 16px)");
var triggerStyles = xcss({
  display: 'inline-flex'
});
var AIIndicatorTooltip = function AIIndicatorTooltip(_ref) {
  var content = _ref.content,
    trigger = _ref.trigger;
  return /*#__PURE__*/React.createElement(Tooltip, {
    component: AIIndicatorTooltipPrimitive,
    content: content,
    tag: "span"
  }, function (tooltipProps) {
    return /*#__PURE__*/React.createElement(Box, _extends({
      xcss: triggerStyles
    }, tooltipProps), trigger);
  });
};
export default AIIndicatorTooltip;